import script from "./TimetableRouteInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./TimetableRouteInfo.vue?vue&type=script&setup=true&lang=ts"

import "./TimetableRouteInfo.vue?vue&type=style&index=0&id=5830a0e1&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5830a0e1"]])

export default __exports__